function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $5225ca3ea613a73e$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"4vJxn":"index.c0b6c00c.js","3KuVe":"star-01 1.963fdfec.png","9qEiC":"Vector.93dd32f0.png","2tjDK":"github.1b7c6384.png"}'));

var $845c0ea234827a91$exports = {};

$845c0ea234827a91$exports = new URL((parcelRequire("27Lyk")).resolve("3KuVe"), import.meta.url).toString();


var $89da5c897e4b43a8$exports = {};

$89da5c897e4b43a8$exports = new URL((parcelRequire("27Lyk")).resolve("9qEiC"), import.meta.url).toString();


var $34bfa2149c4a8d14$exports = {};

$34bfa2149c4a8d14$exports = new URL((parcelRequire("27Lyk")).resolve("2tjDK"), import.meta.url).toString();


const $90446868ca66516a$var$username = "moniabysiak";
const $90446868ca66516a$var$repositoriesContainer = document.querySelector(".projects--js");
fetch(`https://api.github.com/users/${$90446868ca66516a$var$username}/repos`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { name: name, stargazers_count: stargazers_count, html_url: html_url, description: description, topics: topics, homepage: homepage } = repository;
        let tags = ``;
        for (let tag of topics)tags += `<li class="text-white font-bold text-sm px-2 py-1 bg-gray/10 rounded"> ${tag} </li>`;
        const element = `<article
                class="rounded-lg md:rounded-xl overflow-clip bg-gradient-to-br from-white/10 to-white/5 flex flex-col h-full">
                <div
                    class="h-11 bg-gradient-to-br p-4 from-white/10 to-white/5 shadow-inner-light ring-1 ring-inset ring-page rounded-t-lg flex gap-1.5 justify-start items-center">
                    <span class="w-3 h-3 block rounded-full bg-page opacity-50""></span>
                    <span class="w-3 h-3 block rounded-full bg-page opacity-50""></span>
                    <span class="w-3 h-3 block rounded-full bg-page opacity-50""></span>
                </div>
                <div
                    class="h-auto p-5 md:p-6 lg:p-10ring-1 ring-page ring-inset rounded-b-xl flex flex-col grow justify-between">
                    <header class="flex gap-4 items-center mb-4">
                        <h3 class="text-white font-bold text-2xl"> ${name} </h3>
                        <p class="px-2 py-1 gap-1 flex items-center bg-gray/10 text-gray rounded"> <img
                                class="w-4 h-4" src="${(0, (/*@__PURE__*/$parcel$interopDefault($845c0ea234827a91$exports)))}"> ${stargazers_count} </p>
                    </header>
                    <p class="text-gray mb-4 text-xl"> ${description} </p>
                    <ul class="flex gap-2 flex-wrap mb-10">
                        ${tags}
                    </ul>
                    <div class="flex flex-row flex-wrap gap-4 justify-start">
                        <a href= "${homepage}" target="_blank" target="noreferrer nofollow"
                            class="text-pink bg-page py-4 px-5 font-bold text-base md:text-xl rounded-2xl flex gap-3 items-center border-gray-800 border-2 transition-color duration-500 hover:border-pink border-zinc-500">
                            <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($89da5c897e4b43a8$exports)))}" alt> View demo </a>
                        <a href= "${html_url}" target="_blank" target="noreferrer nofollow"
                            class="text-pink bg-page py-4 px-5 font-bold text-base md:text-xl rounded-2xl flex gap-3 items-center border-gray-800 border-2 transition-color duration-500 hover:border-pink border-zinc-500">
                            <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($34bfa2149c4a8d14$exports)))}" alt> Source code </a>
                    </div>
                </div>
            </article>`;
        if (description !== null) $90446868ca66516a$var$repositoriesContainer.insertAdjacentHTML("beforeend", element);
    }
}).catch((e)=>{
    console.log(e);
});


//# sourceMappingURL=index.c0b6c00c.js.map
